export const settingDict = {
    en: {
      "Account": "Account",
      "Change Password": "Change Password",
      "Edit Account": "Edit Account",
      "Subscribe Indiapolls": "Subscribe DX Panel",
      "Request Deletion of Account": "Request Deletion of Account",
      "Gender": "Gender",
      "Mobile": "Mobile",
      "DOB": "DOB",
      "Address": "Address",
      "Pin Code": "Pin Code",
      "Country": "Country",
      "State": "State",
      "City": "City",
      "Profile names to be same as profile": "Profile names to be same as profile",
      "Unsubscribe Confirmation": "Are you sure want to unsubscribe from DX Panel?",
      "Subscribe Confirmation": "Are you sure want to Subscribe DX Panel?",
      "Deletion Confirmation" : "Are you sure want to create delete request?",
      "Verified" : "Verified",
      "Not-Verified" : "Not-Verified", 
      "Unsubscribe From Indiapolls" : "Unsubscribe From DX Panel",
      "Verify" : "Verify"
    },
    hi: {
      "Account": "खाता",
      "Change Password": "पासवर्ड बदलें",
      "Edit Account": "खाता संपादित करें",
      "Subscribe Indiapolls": "DX Panel की सदस्यता लें",
      "Request Deletion of Account": "खाता हटाने का अनुरोध",
      "Gender": "लिंग",
      "Mobile": "मोबाइल",
      "DOB": "जन्म तिथि",
      "Address": "पता",
      "Pin Code": "पिन कोड",
      "Country": "देश",
      "State": "राज्य",
      "City": "शहर",
      "Profile names to be same as profile": "प्रोफ़ाइल नाम प्रोफ़ाइल के समान होने के लिए",
      "Unsubscribe Confirmation": "क्या आप वाकई DX Panel से अनसब्सक्राइब करना चाहते हैं?",
      "Subscribe Confirmation": "क्या आप वाकई DX Panel को सब्सक्राइब करना चाहते हैं?",
      "Deletion Confirmation" : "क्या आप वाकई में हटाने का अनुरोध बनाना चाहते हैं?", 
      "Verified" : "सत्यापित",
      "Not-Verified" : "सत्यापित नहीं है",
      "Unsubscribe From Indiapolls" : "DX Panel से सदस्यता हटाए ",
      "Verify" : "सत्यापित करें"
    },
    jp: {
      "Account": "アカウント",
      "Change Password": "パスワードの変更",
      "Edit Account": "アカウント編集",
      "Subscribe Indiapolls": "DX Panel を購読",
      "Request Deletion of Account": "アカウント削除のリクエスト",
      "Gender": "性別",
      "Mobile": "電話番号",
      "DOB": "生年月日",
      "Address": "住所",
      "Pin Code": "郵便番号",
      "Country": "国",
      "State": "都道府県",
      "City": "市区町村",
      "Profile names to be same as profile": "プロフィール名はプロフィールと同じである必要があります",
      "Unsubscribe Confirmation": "本当に DX Panel の購読を解除しますか？",
      "Subscribe Confirmation": "本当に DX Panel を購読しますか？",
      "Deletion Confirmation" : "削除リクエストを作成してもよろしいですか？",
      "Verified" : "確認済み",
      "Not-Verified" : "未確認",
      "Unsubscribe From Indiapolls" : "DX Panel の購読を解除",
      "Verify" : "確認"
    }
};

export const mobileVerificationDict = {
  en: {
    "Mobile Verification": "Mobile Verification",
    "Enter OTP": "Enter OTP",
    "Verify Mobile": "Verify",
    "Resend OTP": "Resend",
  },
  hi: {
    "Mobile Verification": "मोबाइल सत्यापन",
    "Enter OTP": "ओटीपी दर्ज करें",
    "Verify Mobile": "सत्यापित करें",
    "Resend OTP" : "पुनः भेजे"
  },
  jp: {
    "Mobile Verification": "電話番号確認",
    "Enter OTP": "OTPを入力",
    "Verify Mobile": "確認",
    "Resend OTP": "再送",
  }
};

export const formFieldDict = {
  en: {
    "First name": "First name",
    "Last Name": "Last Name",
    "Full Name": "Full Name",
    "Email": "Email",
    "Mobile Number": "Mobile Number",
    "Gender": "Gender",
    "Date Of Birth": "Date Of Birth",
    "Pincode": "Pincode",
    "Postcode": "Postcode",
    "Address Line 1": "Address Line 1",
    "Address Line 2": "Address Line 2",
    "Address Line": "Address Line",
    "Country": "Country",
    "State": "State",
    "Prefecture": "Prefecture",
    "City": "City",
    "Referral Source": "Referral Source",
    "Submit": "Submit",
    "Reset": "Reset",
    "Enter here": "Enter here",
    "Enter here..": "Enter here..",
    "Choose": "--Choose--",
    "Male": "Male",
    "Female": "Female",
    "Select Referral": "Select Referral",
    "Ad flier with newspaper": "Ad flier with newspaper",
    "Ad flier at market/outdoors": "Ad flier at market/outdoors",
    "Saw an ad on a website": "Saw an ad on a website",
    "Read about it on a blog/forum": "Read about it on a blog/forum",
    "Ad at Café Coffee Day": "Ad at Café Coffee Day",
    "Got an email from a friend/colleague": "Got an email from a friend/colleague",
    "Email from a web portal/service/jobsite": "Email from a web portal/service/jobsite",
    "Searched on google.com": "Searched on google.com",
    "Other": "Other",
    "Searched on another search engine": "Searched on another search engine",
    "Ad at a shop/restaurant": "Ad at a shop/restaurant",
    "Word of mouth from friend/colleague": "Word of mouth from friend/colleague",
    "Update Profile" : "Update Profile"
  },
  hi: {
    "First name": "पहला नाम",
    "Last Name": "उपनाम",
    "Full Name": "Full Name",
    "Email": "ईमेल",
    "Mobile Number": "मोबाइल नंबर",
    "Gender": "लिंग",
    "Date Of Birth": "जन्म की तारीख",
    "Pincode": "पिन कोड",
    "Postcode": "Postcode",
    "Address Line 1": "पता पंक्ति 1",
    "Address Line 2": "पता पंक्ति 2",
    "Address Line": "Address Line",
    "Country": "देश",
    "State": "राज्य",
    "Prefecture": "Prefecture",
    "City": "शहर",
    "Referral Source": "रेफरल स्रोत",
    "Submit": "जमा करें",
    "Reset": "रीसेट करें",
    "Enter here": "यहाँ दर्ज करें",
    "Enter here..": "यहाँ लिखें..",
    "Choose": "--चुनें--",
    "Male": "पुरुष",
    "Female": "महिला",
    "Select Referral": "रेफरल का चयन करें",
    "Ad flier with newspaper": "अखबार के साथ विज्ञापन पत्रक",
    "Ad flier at market/outdoors": "बाजार/बाहर में विज्ञापन पत्रक",
    "Saw an ad on a website": "वेबसाइट पर विज्ञापन देखा",
    "Read about it on a blog/forum": "ब्लॉग/फोरम पर इसके बारे में पढ़ा",
    "Ad at Café Coffee Day": "कैफे कॉफी डे में विज्ञापन",
    "Got an email from a friend/colleague": "दोस्त/सहकर्मी से ईमेल प्राप्त हुआ",
    "Email from a web portal/service/jobsite": "वेब पोर्टल/सेवा/नौकरी साइट से ईमेल",
    "Searched on google.com": "google.com पर खोजा गया",
    "Other": "अन्य",
    "Searched on another search engine": "दूसरे खोज इंजन पर खोजा गया",
    "Ad at a shop/restaurant": "दुकान/रेस्तरां में विज्ञापन",
    "Word of mouth from friend/colleague": "दोस्त/सहकर्मी से मुख से जानकारी",
    "Update Profile" : "प्रोफ़ाइल संपादित करें"
  },
  jp: {
    "First name": "名",
    "Last Name": "姓",
    "Full Name": "氏名",
    "Email": "メールアドレス",
    "Mobile Number": "電話番号",
    "Gender": "性別",
    "Date Of Birth": "生年月日",
    "Pincode": "郵便番号",
    "Postcode": "郵便番号",
    "Address Line 1": "住所1",
    "Address Line 2": "住所2",
    "Address Line": "住所",
    "Country": "国",
    "State": "都道府県",
    "Prefecture": "都道府県",
    "City": "市区町村",
    "Referral Source": "紹介元",
    "Submit": "送信",
    "Reset": "リセット",
    "Enter here": "ここに入力",
    "Enter here..": "ここに入力..",
    "Choose": "--選択してください--",
    "Male": "男性",
    "Female": "女性",
    "Select Referral": "紹介元を選択",
    "Ad flier with newspaper": "新聞のチラシ広告",
    "Ad flier at market/outdoors": "市場・屋外のチラシ広告",
    "Saw an ad on a website": "ウェブサイトの広告を見た",
    "Read about it on a blog/forum": "ブログ・フォーラムで読んだ",
    "Ad at Café Coffee Day": "カフェ・コーヒー・デイの広告",
    "Got an email from a friend/colleague": "友人・同僚からメールを受け取った",
    "Email from a web portal/service/jobsite": "ウェブポータル・サービス・求人サイトからのメール",
    "Searched on google.com": "google.comで検索",
    "Other": "その他",
    "Searched on another search engine": "別の検索エンジンで検索",
    "Ad at a shop/restaurant": "店舗・レストランの広告",
    "Word of mouth from friend/colleague": "友人・同僚からの口コミ",
    "Update Profile" : "プロフィール更新"
  }
};

export const confirmationDict = {
  en: {
    "Confirmation": "Confirmation",
    "Are you sure?": "Are you sure?",
    "Changeable": "Changeable"
  },
  hi: {
    "Confirmation": "पुष्टिकरण",
    "Are you sure?": "क्या आपको यकीन है?",
    "Changeable": "परिवर्तनीय"
  },
  jp: {
    "Confirmation": "確認",
    "Are you sure?": "本当によろしいですか？",
    "Changeable": "変更可能"
  }
};


